import React from "react";
import { Box, Typography, Container, useTheme, Paper } from "@mui/material";
import { welcome } from "../context/welcome";

export default function LandingPage() {
    const theme = useTheme();

    return (
        <>
            {/* Full-width banner with image */}
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: { xs: "200px", md: "300px" },
                    backgroundImage: "url(/dijk-aanleg-banner.jpg)", // Add your dike construction image to the public folder
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        // backgroundColor: "rgba(27, 47, 104, 0.6)", // Dark blue overlay with transparency
                    },
                }}
            >
                {/* Overlay content */}
                <Container
                    maxWidth="lg"
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        textAlign: "center",
                        color: theme.palette.text.white,
                        px: { xs: 2, md: 4 },
                    }}
                >
                    <Typography
                        variant="h2"
                        component="h1"
                        gutterBottom
                        sx={{
                            fontWeight: 600,
                            mb: 3,
                            textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                            fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                        }}
                    >
                        {welcome.title}
                    </Typography>
                </Container>
            </Box>

            {/* Content section below banner */}
            <Container maxWidth="xl" sx={{ mt: 4, mb: 2 }} component={Paper}>
                <Box sx={{ textAlign: "center", mb: 4 }}>
                    <Typography variant="h4" component="h2" gutterBottom color="primary.dark">
                        Over deze tool
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontSize: "1.1rem", lineHeight: 1.8 }}>
                        {welcome.paragraphs[0].introduction}
                    </Typography>
                    <Box component="ul" sx={{ textAlign: "left", maxWidth: "800px", mx: "auto", mt: 3 }}>
                        {welcome.paragraphs[0].listItems.map((item, index) => (
                            <Typography
                                key={index}
                                component="li"
                                variant="body1"
                                sx={{ mb: 2, fontSize: "1.1rem", lineHeight: 1.8 }}
                            >
                                {item}
                            </Typography>
                        ))}
                    </Box>
                </Box>
            </Container>
        </>
    );
}
